import { Component, Input } from '@angular/core';

import { statusPretendidoPotencial } from '../../cliente-analise-mercado-status-pretendido';
import { ClienteAnaliseMercadoStatusPretendidoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-badge-pill-potencial',
    templateUrl: './cliente-analise-mercado-status-pretendido-badge-pill-potencial.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-badge-pill-potencial.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoBadgePillPotencialComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusPretendidoPipe: ClienteAnaliseMercadoStatusPretendidoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusPretendidoPipe.transform(statusPretendidoPotencial.id);
    }
}
